import React from 'react';

const Loader = () => {
  return (
    <div className="cine-loader">
      <div className="cine-loader-ring" />
      <div className="cine-loader-text">Searching for movies</div>
      <div className="cine-loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
